import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";


function QF()
{
    return (
        <div>
            <Helmet>
                <title>Home | QF | Lucas RODRIGUEZ</title>
            </Helmet>
            <h2>M2QF - Quantitative Finance</h2>

            <p>
                Please find below online resources related to my academic projects during my final-year of
                studies at <a href="https://www.universite-paris-saclay.fr/en/education/master/mathematics-and-applications/m2-quantitative-finance" target="_BLANK">M2 Quantitative Finance</a> (<a href="https://www.universite-paris-saclay.fr/en/" target="_BLANK">University of Paris-Saclay</a>).
            </p>

            <hr class="col-3 col-md-4 mb-4" />

            <p>
                <ol>
                    <li><NavLink to="/qf/ml/">Machine Learning for Finance ◇ Cryptotrading project</NavLink></li>
                    <li><NavLink to="/qf/cutting-edge/">Cutting-Edge project ◇ Equity-Rates ESG & Parameter analysis project</NavLink></li>
                </ol>
            </p>


            <hr class="col-3 col-md-4 mb-4" />
            <p className="text-muted small">
                Work under license
            </p>
        </div >
    );
}

export default QF;